import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAuth from '@websanova/vue-auth'
import router from './router';
import store from "./store";
import vuetify from './plugins/vuetify';
import 'dayjs/locale/ru';
import dayjs from "dayjs";
import Confirm from './plugins/confirm';
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import moment from 'moment';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import * as constants from './constants';

require('./plugins/vee-validate');

moment.locale('ru');

// Register it globally
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

Vue.use(Confirm);

dayjs.locale('ru');
dayjs.extend(customParseFormat);

Vue.prototype.$dayjs = dayjs;

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL;

Vue.router = router;

// Vue Auth
Vue.use(VueAuth, {
    refreshData: {enabled: false, interval: 0},
    auth       : require('./lib/vue-auth/drivers/auth/params'),
    http       : require('./lib/vue-auth/drivers/http/axios.1.x'),
    router     : require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
    logoutData : {url: 'auth/logout', method: 'POST', redirect: {name: 'login'}, makeRequest: true},
    fetchData  : {url: 'profile', method: 'GET', enabled: true},
});

Vue.prototype.$constants = constants;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./components/', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

new Vue({
    render: h => h(App),
    router,
    vuetify,
    store
}).$mount('#app');
